module.exports = __webpack_public_path__ + "img/mobile-export.6bd28732.svg";